const usePostedMessage = (callback) => {
  useEffect(() => {
    window.addEventListener("message", callback);

    return () => window.removeEventListener("message", callback);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default usePostedMessage;
